/**
 * URL Template (RFC 6570) Transform.
 */

var UrlTemplate = require('../lib/url-template');

module.exports = function (options) {

    var variables = [], url = UrlTemplate.expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-resource/src/url/template.js
 ** module id = 107
 ** module chunks = 0
 **/